import './Dashboard.scss';

import MainInfoBlock from './MainInfoBlock';

const Dashboard = () => (
  <section className="home-page tw-pb-4">
    <MainInfoBlock />
  </section>
);

export default Dashboard;
